import React from 'react';
import styles from './CustomLoading.module.scss';

const CustomLoading = () => {
  return (
    <div className={styles['container']} data-testid="custom-loading">
      <div className={styles['icon-wrapper']}>
        <img src="assets/loading.png" alt="icon-loading" />
      </div>
    </div>
  );
};

export default CustomLoading;
